<template>
  <base-modal
    hide-footer
    :size="'xl'"
    :modal-id="'assign-banner'"
    @hidden="$emit('onCloseModal')"
    @show="onOpenModal"
  >
    <b-row class="modal-body-container mb-1 px-2">
      <b-col
        cols="12"
        class="mb-2"
      >
        <span class="assign-modal-title">{{
          isSet ? 'Assign Banner Set' : 'Assign Banner Group'
        }}</span>
      </b-col>
      <b-col
        cols="12"
        class="d-flex justify-content-center mb-1"
      >
        <div class="search-assign-banner-container">
          <search :on-search-input="onSearchBanner" />
        </div>
      </b-col>
      <b-col
        cols="12"
        class="mb-1"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :key="keyChange"
              :fields="isSet ? bannerSetField : bannerGroupField"
              :items="isSet ? setBannerTable.payload : groupBannerTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              class="assign-banner-table"
            >
              <template #cell(valid_from)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_from)
                }}</span>
              </template>
              <template #cell(valid_through)="data">
                <span>{{
                  resolveDateWithSeperator(data.item.valid_through)
                }}</span>
              </template>
              <template #cell(status)="data">
                <div
                  v-if="data.item.status"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    v-if="data.item.status"
                    icon="CircleIcon"
                    class="active-icon mr-2"
                  />
                  <span>{{ resolveBannerStatusLabel(data.item.status) }}</span>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CircleIcon"
                    class="inActive-icon mr-2"
                  />
                  <span class="inActive-label">{{
                    resolveBannerStatusLabel(data.item.status)
                  }}</span>
                </div>
              </template>
              <template #cell(actions)="data">
                <add-banner-button
                  :btn-label="
                    isSet ? 'Assign Banner Set' : 'Assign Banner Group'
                  "
                  :disabled="data.item.assigned"
                  @click.native="onClickAssignButton(data.item)"
                />
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col
        cols="12"
        class="mb-1"
      >
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
  </base-modal>
</template>
<script>
import {
  BRow, BCol, BButton, BSpinner, BTable,
} from 'bootstrap-vue'
import BaseModal from '@core/components/base-modal/BaseModal.vue'
import Search from '@/views/components/search/Search.vue'
import vSelect from 'vue-select'
import AddBannerButton from '@/views/components/button/AddBannerButton.vue'
import CardNoItem from '@core/components/card-no-item/CardNoItem.vue'

import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useAssignBannerModal from '../hooks/useAssignBannerModal'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BaseModal,
    BSpinner,
    BTable,
    Search,
    AddBannerButton,
    CardNoItem,
    vSelect,
    PaginationWithReorder,
  },
  props: {
    isSet: Boolean,
    bannerId: Number,
    isSetBanner: Boolean,
  },
  setup(props) {
    const {
      bannerGroupField,
      bannerSetField,
      setBannerTable,
      groupBannerTable,
      pagination,
      keyChange,
      loading,
      onOpenModal,
      resolveBannerStatusLabel,
      onClickAssignButton,
      onSearchBanner,
      onPageChange,
      resolveDateWithSeperator,
    } = useAssignBannerModal(props)

    return {
      bannerGroupField,
      bannerSetField,
      setBannerTable,
      groupBannerTable,
      pagination,
      keyChange,
      loading,
      onOpenModal,
      resolveBannerStatusLabel,
      onClickAssignButton,
      onSearchBanner,
      onPageChange,
      resolveDateWithSeperator,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/override-styles/loading.css';
@import '~@/assets/css/override-styles/status.css';
@import '~@/assets/css/pages/banner/assign-banner-modal.css';
</style>
